import React from 'react';

import ArrowLeft from '@images/svg-icons/arrowLeft.svg';

interface Props {
    label: string;
    subtitle?: string;
    children: React.ReactNode;
}

const ButtonMenu = ({ label, subtitle, children }: Props): JSX.Element => {
    return (
        <div className="menu-button-link">
            {children}
            <div className="menu-button-link-text">
                {label}
                <span className="subtitle">{!!subtitle && subtitle}</span>
            </div>
            <div className="arrow-menu">
                <ArrowLeft />
            </div>
        </div>
    );
};
export default ButtonMenu;
